// Footer.js
import React from 'react';
import './Footer.css';
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaEnvelope,
  FaInstagram,
} from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-container'>
        <div>
          <img src='./assets/primary_logo.png' alt="signature" height="72" />
        </div>
        <p className='text-center'>"If you want to go fast, go alone. If you want to go far, go together"</p>
        <div className="social-media-handles-container">
        <span className='icon-container'>
            <FaEnvelope onClick={() => {
              window.location.href = 'mailto:futureethicsmedia@gmail.com';
            }} />
          </span>
          <span className='icon-container'>
            <FaFacebookF onClick={() => {
              window.open('https://www.facebook.com/futureethicsmedia');
            }} />
          </span>
          <span className='icon-container'>
            <FaLinkedinIn onClick={() => {
              window.open('https://www.linkedin.com/company/future-ethics-media');
            }} />
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
